require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./indikator-2024-25.json") })
        }
      }, "path---indikator-2024-25");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---indikator-2024-25!./.cache/json/indikator-2024-25.json
// module id = 1044
// module chunks = 231608221292675